import {useEffect, useState} from 'react';
import api from 'helpers/api';
import Modal from 'components/miscellaneous/Modal/Modal';
import styles from './DeleteReport.module.scss';
import {$t} from 'helpers/translator';
import Loader from 'components/miscellaneous/Loader/Loader';

const DeleteReport = ({report, show, onClose, onSuccess}) => {
    const [showModal, setShowModal] = useState(false);
    const [reportDeleted, setReportDeleted] = useState(false);

    useEffect(() => {
        if (show !== showModal) {
            setShowModal(show);
        }
    }, [show])

    const deleteReport = async () => {
        try {
            const res = await api.delete(`/report/${report.token}`);
            if (res && res.success && res.data.success) {
                setShowModal(false);
                onSuccess();
                return res.data.data;
            }
        } catch (e) {
            console.error(e, 'delete report error')
        }
    }

    const cancelDeleteReport = async () => {
        try {
            setShowModal(false);
            onClose();
        } catch (e) {

        }
    }

    return (
        <Modal content={
            <div style={{
                maxWidth: '100%',
                textAlign: 'center',
                padding: '25px 0'
            }}>
                <h3>{$t('global.clinics.deletionIsPermanent')}</h3>
                <div className={`${styles['buttons-container']}`}>
                    <div className={`${styles['delete-cancel']}`} onClick={() => cancelDeleteReport()}>
                        <div className={`${styles['cancel-button']}`}>{$t('global.general.cancel')}</div>
                    </div>
                    <div className={`${styles['delete-approve']}`} onClick={() => deleteReport()}>
                        <div className={`${styles['delete-button']}`}>{$t('global.general.delete')}</div>
                    </div>
                </div>

            </div>
        }
               onClose={(e) => {
                   setShowModal(false);
                   onClose();
               }} visible={showModal}/>
    )
}

export default DeleteReport;